import styled from "styled-components";
import { Link } from "wouter";

export const FlexLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
`;